import { defineAction } from '~/prix'
import { citizenObject } from '../citizenObject'
import citizenListAction from './citizenList.action.json' with { type: 'json' }
import expression from '~/prix/types/expression'
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

export const citizenExpression = expression(citizenObject.shape)

const citizenListDefinition = defineAction({
  ...citizenListAction,
  input: z.object({
    filter: citizenExpression.nullish(),
    limit: z.number().min(1).max(15000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      fullName: 'Nome completo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(
      citizenObject.extend({
        cns: z.string().nullish(),
        clientId: z.number().nullish(),
        originalId: z.string().nullish(),
        dataSourceId: z.number().nullish(),
      }),
    ),
    count: z.number(),
  }),
})

export default citizenListDefinition
